<app-entity-mat-dialog-title [title]="reportTitle"></app-entity-mat-dialog-title>

<div mat-dialog-content class="report-content">
  <!-- Report Header Info -->
  <div class="report-header-info">
    <div class="report-meta">
      <div class="report-icon" [ngClass]="getIconColorClass()">
        <mat-icon>{{ reportIcon }}</mat-icon>
      </div>
      <div class="report-details">
        <span class="week-badge">Week {{ data.week }}, {{ data.year }}</span>
        <span class="studio-name" *ngIf="data.reportData?.studio?.name">{{ data.reportData.studio.name }}</span>
      </div>
    </div>
    <div class="submission-info" *ngIf="data.reportData?.created_at">
      <span class="info-label">Submitted:</span>
      <span class="info-value">{{ formatDate(data.reportData.created_at) }}</span>
    </div>
  </div>

  <!-- Report Summary Card -->
  <mat-card class="summary-card mb-4">
    <mat-card-header>
      <mat-card-title>Report Summary</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="row">
        <div class="col-md-3 col-6">
          <div class="summary-metric">
            <span class="metric-label">Prepared By</span>
            <span class="metric-value">{{ data.reportData?.prepared_by || 'N/A' }}</span>
          </div>
        </div>
        <div class="col-md-3 col-6">
          <div class="summary-metric">
            <span class="metric-label">Week Ending</span>
            <span class="metric-value">{{ formatDate(data.reportData?.week_ending) }}</span>
          </div>
        </div>
        <div class="col-md-3 col-6" *ngIf="data.reportData?.revised !== undefined">
          <div class="summary-metric">
            <span class="metric-label">Revised</span>
            <span class="metric-value">{{ data.reportData?.revised ? 'Yes' : 'No' }}</span>
          </div>
        </div>
        <div class="col-md-3 col-6" *ngIf="data.reportData?.last_transmitted_client">
          <div class="summary-metric">
            <span class="metric-label">Transmitted Via</span>
            <span class="metric-value">{{ data.reportData?.last_transmitted_client }}</span>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- Royalty Report Details -->
  <ng-container *ngIf="data.reportType === 'royalty'">
    <mat-card class="details-card mb-4">
      <mat-card-header>
        <mat-card-title>Royalty Details</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="row">
          <div class="col-md-3 col-6">
            <div class="metric-circle royalty">
              <span class="metric-number">{{ data.reportData?.royalty_percentage || 0 }}%</span>
            </div>
            <div class="metric-label-below">Royalty Rate</div>
          </div>
          <div class="col-md-3 col-6">
            <div class="metric-circle exchange">
              <span class="metric-number">{{ data.reportData?.exchange_rate || 1 }}</span>
            </div>
            <div class="metric-label-below">Exchange Rate</div>
          </div>
          <div class="col-md-3 col-6">
            <div class="metric-circle withholding">
              <span class="metric-number">{{ data.reportData?.foreign_witholding_percentage || 0 }}%</span>
            </div>
            <div class="metric-label-below">Foreign Withholding</div>
          </div>
          <div class="col-md-3 col-6">
            <div class="metric-circle release">
              <span class="metric-number">{{ data.reportData?.release_territory_percentage || 0 }}%</span>
            </div>
            <div class="metric-label-below">Release Territory</div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Receipts Table -->
    <mat-card class="table-card mb-4" *ngIf="data.reportData?.line_items?.length">
      <mat-card-header>
        <mat-card-title>All Receipts ({{ data.reportData.line_items.length }} items)</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="table-responsive">
          <table class="mat-table cdk-table w-100" role="table">
            <thead role="rowgroup">
              <tr>
                <th class="mat-header-cell">Receipt #</th>
                <th class="mat-header-cell">Date Paid</th>
                <th class="mat-header-cell">Student</th>
                <th class="mat-header-cell">Executive</th>
                <th class="mat-header-cell">Staff Member</th>
                <th class="mat-header-cell">Sale Code</th>
                <th class="mat-header-cell">Units</th>
                <th class="mat-header-cell">Sale Value</th>
                <th class="mat-header-cell">Cash</th>
                <th class="mat-header-cell">Misc/Non Unit</th>
                <th class="mat-header-cell">Sundry</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of data.reportData.line_items"
                  [ngClass]="{'refund-row': getRoyaltyLineTotal(item) < 0}">
                <td class="mat-row">{{ item.receipt_number }}</td>
                <td class="mat-row">{{ formatDate(item.date_paid) }}</td>
                <td class="mat-row">{{ item.students_full_name || 'N/A' }}</td>
                <td class="mat-row">{{ getRoyaltyExecutiveName(item) }}</td>
                <td class="mat-row">{{ getRoyaltyStaffName(item) }}</td>
                <td class="mat-row">{{ item.sale_code || '' }}</td>
                <td class="mat-row">{{ item.number_of_units || 0 }}</td>
                <td class="mat-row">{{ formatCurrency(item.sale_value) }}</td>
                <td class="mat-row">{{ formatCurrency(item.cash) }}</td>
                <td class="mat-row">{{ formatCurrency(item.miscellaneous_services) }}</td>
                <td class="mat-row">{{ formatCurrency(item.sundry) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Summary Totals -->
    <mat-card class="table-card mb-4" *ngIf="data.reportData?.line_items?.length">
      <mat-card-header>
        <mat-card-title>Summary</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="table-responsive">
          <table class="mat-table cdk-table w-100" role="table">
            <thead role="rowgroup">
              <tr>
                <th class="mat-header-cell"></th>
                <th class="mat-header-cell">Cash</th>
                <th class="mat-header-cell">Misc Services</th>
                <th class="mat-header-cell">Sundry</th>
                <th class="mat-header-cell">Total Receipts</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="mat-row">Totals</td>
                <td class="mat-row">{{ formatCurrency(getRoyaltySummary().cash) }}</td>
                <td class="mat-row">{{ formatCurrency(getRoyaltySummary().miscellaneous_services) }}</td>
                <td class="mat-row">{{ formatCurrency(getRoyaltySummary().sundry) }}</td>
                <td class="mat-row">{{ formatCurrency(getRoyaltySummary().total) }}</td>
              </tr>
              <tr>
                <td class="mat-row">Deduct Refunds/Credits</td>
                <td class="mat-row">{{ formatCurrency(getRoyaltySummary().refund_cash) }}</td>
                <td class="mat-row">{{ formatCurrency(getRoyaltySummary().refund_miscellaneous) }}</td>
                <td class="mat-row">{{ formatCurrency(getRoyaltySummary().refund_sundry) }}</td>
                <td class="mat-row">{{ formatCurrency(getRoyaltySummary().refund_total) }}</td>
              </tr>
              <tr>
                <td class="mat-row"><strong>Total Subject To Percentage</strong></td>
                <td class="mat-row"><strong>{{ formatCurrency(getRoyaltySummary().net_cash) }}</strong></td>
                <td class="mat-row"><strong>{{ formatCurrency(getRoyaltySummary().net_miscellaneous) }}</strong></td>
                <td class="mat-row"><strong>{{ formatCurrency(getRoyaltySummary().net_sundry) }}</strong></td>
                <td class="mat-row"><strong>{{ formatCurrency(getRoyaltySummary().net_total) }}</strong></td>
              </tr>
              <tr>
                <td class="mat-row">Weekly Net Due ({{ data.reportData?.royalty_percentage || data.reportData?.studio?.royalty_percentage || 0 }}%)</td>
                <td class="mat-row">{{ formatCurrency(getRoyaltySummary().net_cash * (data.reportData?.royalty_percentage || data.reportData?.studio?.royalty_percentage || 0) / 100) }}</td>
                <td class="mat-row">{{ formatCurrency(getRoyaltySummary().net_miscellaneous * (data.reportData?.royalty_percentage || data.reportData?.studio?.royalty_percentage || 0) / 100) }}</td>
                <td class="mat-row">{{ 0 | studioCurrency }}</td>
                <td class="mat-row"><strong>{{ formatCurrency(getRoyaltySummary().net_total * (data.reportData?.royalty_percentage || data.reportData?.studio?.royalty_percentage || 0) / 100) }}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-container>

  <!-- Staff Performance Report Details -->
  <ng-container *ngIf="data.reportType === 'staff_performance'">
    <!-- Instructors Table -->
    <mat-card class="table-card mb-4" *ngIf="getStaffByType('INSTRUCTOR').length">
      <mat-card-header>
        <mat-card-title>Instructors</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="table-responsive">
          <table mat-table [dataSource]="getStaffByType('INSTRUCTOR')" class="w-100">
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Name</th>
              <td mat-cell *matCellDef="let item">{{ getStaffMemberName(item) }}</td>
            </ng-container>

            <ng-container matColumnDef="number_guests">
              <th mat-header-cell *matHeaderCellDef>Guests</th>
              <td mat-cell *matCellDef="let item">{{ item.number_guests || 0 }}</td>
            </ng-container>

            <ng-container matColumnDef="private_lessons">
              <th mat-header-cell *matHeaderCellDef>Personal Lessons</th>
              <td mat-cell *matCellDef="let item">{{ item.private_lessons || 0 }}</td>
            </ng-container>

            <ng-container matColumnDef="number_in_class">
              <th mat-header-cell *matHeaderCellDef>Number in Class</th>
              <td mat-cell *matCellDef="let item">{{ item.number_in_class || 0 }}</td>
            </ng-container>

            <ng-container matColumnDef="dor_sanct_competition">
              <th mat-header-cell *matHeaderCellDef>Dor/Sanct. Competition</th>
              <td mat-cell *matCellDef="let item">{{ item.dor_sanct_competition ? formatCurrency(item.dor_sanct_competition) : '$0' }}</td>
            </ng-container>

            <ng-container matColumnDef="showcase_medal_ball">
              <th mat-header-cell *matHeaderCellDef>Showcase Medal Ball</th>
              <td mat-cell *matCellDef="let item">{{ item.showcase_medal_ball ? formatCurrency(item.showcase_medal_ball) : '$0' }}</td>
            </ng-container>

            <ng-container matColumnDef="party_time_non_unit">
              <th mat-header-cell *matHeaderCellDef>Party Time Non-Unit</th>
              <td mat-cell *matCellDef="let item">{{ item.party_time_non_unit ? formatCurrency(item.party_time_non_unit) : '$0' }}</td>
            </ng-container>

            <ng-container matColumnDef="interview_department">
              <th mat-header-cell *matHeaderCellDef>Interview Dept</th>
              <td mat-cell *matCellDef="let item">{{ item.interview_department ? formatCurrency(item.interview_department) : '$0' }}</td>
            </ng-container>

            <ng-container matColumnDef="renewal_department">
              <th mat-header-cell *matHeaderCellDef>Renewal Dept</th>
              <td mat-cell *matCellDef="let item">{{ item.renewal_department ? formatCurrency(item.renewal_department) : '$0' }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="staffPerformanceColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: staffPerformanceColumns;"></tr>
          </table>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Executives Table -->
    <mat-card class="table-card mb-4" *ngIf="getStaffByType('EXECUTIVE').length">
      <mat-card-header>
        <mat-card-title>Executives</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="table-responsive">
          <table mat-table [dataSource]="getStaffByType('EXECUTIVE')" class="w-100">
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Name</th>
              <td mat-cell *matCellDef="let item">{{ getStaffMemberName(item) }}</td>
            </ng-container>

            <ng-container matColumnDef="number_guests">
              <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
              <td mat-cell *matCellDef="let item">&nbsp;</td>
            </ng-container>

            <ng-container matColumnDef="private_lessons">
              <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
              <td mat-cell *matCellDef="let item">&nbsp;</td>
            </ng-container>

            <ng-container matColumnDef="number_in_class">
              <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
              <td mat-cell *matCellDef="let item">&nbsp;</td>
            </ng-container>

            <ng-container matColumnDef="dor_sanct_competition">
              <th mat-header-cell *matHeaderCellDef>Dor/Sanct. Competition</th>
              <td mat-cell *matCellDef="let item">{{ item.dor_sanct_competition ? formatCurrency(item.dor_sanct_competition) : '$0' }}</td>
            </ng-container>

            <ng-container matColumnDef="showcase_medal_ball">
              <th mat-header-cell *matHeaderCellDef>Showcase Medal Ball</th>
              <td mat-cell *matCellDef="let item">{{ item.showcase_medal_ball ? formatCurrency(item.showcase_medal_ball) : '$0' }}</td>
            </ng-container>

            <ng-container matColumnDef="party_time_non_unit">
              <th mat-header-cell *matHeaderCellDef>Party Time Non-Unit</th>
              <td mat-cell *matCellDef="let item">{{ item.party_time_non_unit ? formatCurrency(item.party_time_non_unit) : '$0' }}</td>
            </ng-container>

            <ng-container matColumnDef="interview_department">
              <th mat-header-cell *matHeaderCellDef>Interview Dept</th>
              <td mat-cell *matCellDef="let item">{{ item.interview_department ? formatCurrency(item.interview_department) : '$0' }}</td>
            </ng-container>

            <ng-container matColumnDef="renewal_department">
              <th mat-header-cell *matHeaderCellDef>Renewal Dept</th>
              <td mat-cell *matCellDef="let item">{{ item.renewal_department ? formatCurrency(item.renewal_department) : '$0' }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="staffPerformanceColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: staffPerformanceColumns;"></tr>
          </table>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-container>

  <!-- Studio Business Report Details -->
  <ng-container *ngIf="data.reportType === 'studio_business'">
    <!-- Cash Receipts -->
    <mat-card class="table-card mb-4">
      <mat-card-header>
        <mat-card-title>Cash Receipts</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="table-responsive">
          <table class="mat-table cdk-table w-100" role="table">
            <thead role="rowgroup">
              <tr>
                <th class="mat-header-cell"></th>
                <th class="mat-header-cell">Lessons</th>
                <th class="mat-header-cell">Misc</th>
                <th class="mat-header-cell">Totals</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="mat-row">Current</td>
                <td class="mat-row">{{ formatCurrency(data.reportData?.cash) }}</td>
                <td class="mat-row">{{ formatCurrency(data.reportData?.miscellaneous) }}</td>
                <td class="mat-row">{{ formatCurrency((data.reportData?.cash || 0) + (data.reportData?.miscellaneous || 0)) }}</td>
              </tr>
              <tr>
                <td class="mat-row">Refund</td>
                <td class="mat-row">({{ formatCurrency(Math.abs(data.reportData?.refund_cash || 0)) }})</td>
                <td class="mat-row">({{ formatCurrency(Math.abs(data.reportData?.refund_miscellaneous || 0)) }})</td>
                <td class="mat-row">({{ formatCurrency(Math.abs((data.reportData?.refund_cash || 0) + (data.reportData?.refund_miscellaneous || 0))) }})</td>
              </tr>
              <tr>
                <td class="mat-row"><strong>Total</strong></td>
                <td class="mat-row"><strong>{{ formatCurrency((data.reportData?.cash || 0) + (data.reportData?.refund_cash || 0)) }}</strong></td>
                <td class="mat-row"><strong>{{ formatCurrency((data.reportData?.miscellaneous || 0) + (data.reportData?.refund_miscellaneous || 0)) }}</strong></td>
                <td class="mat-row"><strong>{{ formatCurrency((data.reportData?.cash || 0) + (data.reportData?.miscellaneous || 0) + (data.reportData?.refund_cash || 0) + (data.reportData?.refund_miscellaneous || 0)) }}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row mt-3" *ngIf="data.reportData?.total_taxes">
          <div class="col-md-4 col-6">
            <div class="summary-metric">
              <span class="metric-label">Total Taxes</span>
              <span class="metric-value">{{ formatCurrency(data.reportData?.total_taxes) }}</span>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Inquiries -->
    <mat-card class="table-card mb-4">
      <mat-card-header>
        <mat-card-title>Inquiries</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="table-responsive">
          <table class="mat-table cdk-table w-100" role="table">
            <thead role="rowgroup">
              <tr>
                <th class="mat-header-cell">Contact</th>
                <th class="mat-header-cell">Booked</th>
                <th class="mat-header-cell">Showed</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="mat-row">{{ data.reportData?.contact || 0 }}</td>
                <td class="mat-row">{{ data.reportData?.booked || 0 }}</td>
                <td class="mat-row">{{ data.reportData?.showed || 0 }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Lessons Taught -->
    <mat-card class="table-card mb-4">
      <mat-card-header>
        <mat-card-title>Lessons Taught</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="table-responsive">
          <table class="mat-table cdk-table w-100" role="table">
            <thead role="rowgroup">
              <tr>
                <th class="mat-header-cell">Pvt. Int.</th>
                <th class="mat-header-cell">Pvt. Ren.</th>
                <th class="mat-header-cell"># in Class</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="mat-row">{{ data.reportData?.lessons_interviewed || 0 }}</td>
                <td class="mat-row">{{ data.reportData?.lessons_renewed || 0 }}</td>
                <td class="mat-row">{{ data.reportData?.number_in_class || 0 }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row mt-3">
          <div class="col-md-4 col-6">
            <div class="summary-metric">
              <span class="metric-label">Active (Interview)</span>
              <span class="metric-value">{{ data.reportData?.active_students_interview || 0 }}</span>
            </div>
          </div>
          <div class="col-md-4 col-6">
            <div class="summary-metric">
              <span class="metric-label">Active (Renewal)</span>
              <span class="metric-value">{{ data.reportData?.active_students_renewal || 0 }}</span>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Unit Sales Tracking -->
    <mat-card class="table-card mb-4">
      <mat-card-header>
        <mat-card-title>Unit Sales Tracking</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="table-responsive">
          <table class="mat-table cdk-table w-100" role="table">
            <thead role="rowgroup">
              <tr>
                <th class="mat-header-cell"></th>
                <th class="mat-header-cell">Tries</th>
                <th class="mat-header-cell">Sold</th>
                <th class="mat-header-cell">Units</th>
                <th class="mat-header-cell">Sales</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="mat-row"><strong>Pre-Original</strong></td>
                <td class="mat-row">{{ data.reportData?.pre_original_tried || 0 }}</td>
                <td class="mat-row">{{ data.reportData?.pre_original_sold || 0 }}</td>
                <td class="mat-row">{{ data.reportData?.pre_original_units || 0 }}</td>
                <td class="mat-row">{{ formatCurrency(data.reportData?.pre_original_sales) }}</td>
              </tr>
              <tr>
                <td class="mat-row"><strong>Original</strong></td>
                <td class="mat-row">{{ data.reportData?.original_tried || 0 }}</td>
                <td class="mat-row">{{ data.reportData?.original_sold || 0 }}</td>
                <td class="mat-row">{{ data.reportData?.original_units || 0 }}</td>
                <td class="mat-row">{{ formatCurrency(data.reportData?.original_sales) }}</td>
              </tr>
              <tr>
                <td class="mat-row"><strong>Extension</strong></td>
                <td class="mat-row">{{ data.reportData?.extension_tried || 0 }}</td>
                <td class="mat-row">{{ data.reportData?.extension_sold || 0 }}</td>
                <td class="mat-row">{{ data.reportData?.extension_units || 0 }}</td>
                <td class="mat-row">{{ formatCurrency(data.reportData?.extension_sales) }}</td>
              </tr>
              <tr>
                <td class="mat-row"><strong>Renewal</strong></td>
                <td class="mat-row">{{ data.reportData?.renewal_tried || 0 }}</td>
                <td class="mat-row">{{ data.reportData?.renewal_sold || 0 }}</td>
                <td class="mat-row">{{ data.reportData?.renewal_units || 0 }}</td>
                <td class="mat-row">{{ formatCurrency(data.reportData?.renewal_sales) }}</td>
              </tr>
              <tr style="border-top: 2px solid #ccc;">
                <td class="mat-row"><strong>Total</strong></td>
                <td class="mat-row"><strong>{{ (data.reportData?.pre_original_tried || 0) + (data.reportData?.original_tried || 0) + (data.reportData?.extension_tried || 0) + (data.reportData?.renewal_tried || 0) }}</strong></td>
                <td class="mat-row"><strong>{{ (data.reportData?.pre_original_sold || 0) + (data.reportData?.original_sold || 0) + (data.reportData?.extension_sold || 0) + (data.reportData?.renewal_sold || 0) }}</strong></td>
                <td class="mat-row"><strong>{{ (data.reportData?.pre_original_units || 0) + (data.reportData?.original_units || 0) + (data.reportData?.extension_units || 0) + (data.reportData?.renewal_units || 0) }}</strong></td>
                <td class="mat-row"><strong>{{ formatCurrency((data.reportData?.pre_original_sales || 0) + (data.reportData?.original_sales || 0) + (data.reportData?.extension_sales || 0) + (data.reportData?.renewal_sales || 0)) }}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Non-Unit Sales & Miscellaneous -->
    <mat-card class="table-card mb-4">
      <mat-card-header>
        <mat-card-title>Non-Unit Sales &amp; Miscellaneous</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="table-responsive">
          <table class="mat-table cdk-table w-100" role="table">
            <thead role="rowgroup">
              <tr>
                <th class="mat-header-cell"></th>
                <th class="mat-header-cell">Lessons</th>
                <th class="mat-header-cell">Sales</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="mat-row"><strong>PVT/Coach</strong></td>
                <td class="mat-row">{{ data.reportData?.non_unit_private_lessons || 0 }}</td>
                <td class="mat-row">{{ formatCurrency(data.reportData?.non_unit_private_sales) }}</td>
              </tr>
              <tr>
                <td class="mat-row"><strong>Class</strong></td>
                <td class="mat-row">{{ data.reportData?.non_unit_class_lessons || 0 }}</td>
                <td class="mat-row">{{ formatCurrency(data.reportData?.non_unit_class_sales) }}</td>
              </tr>
              <tr>
                <td class="mat-row"><strong>Miscellaneous Events</strong></td>
                <td class="mat-row"></td>
                <td class="mat-row">{{ formatCurrency(data.reportData?.miscellaneous_sales) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-container>

  <!-- Miscellaneous Report Details -->
  <ng-container *ngIf="data.reportType === 'miscellaneous'">
    <mat-card class="details-card mb-4">
      <mat-card-header>
        <mat-card-title>Event Details</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="row">
          <div class="col-md-6" *ngIf="data.reportData?.event">
            <div class="summary-metric">
              <span class="metric-label">Event</span>
              <span class="metric-value">{{ data.reportData?.event }}</span>
            </div>
          </div>
          <div class="col-md-6" *ngIf="data.reportData?.location">
            <div class="summary-metric">
              <span class="metric-label">Location</span>
              <span class="metric-value">{{ data.reportData?.location }}</span>
            </div>
          </div>
          <div class="col-md-3 col-6" *ngIf="data.reportData?.date_started">
            <div class="summary-metric">
              <span class="metric-label">Date Started</span>
              <span class="metric-value">{{ formatDate(data.reportData?.date_started) }}</span>
            </div>
          </div>
          <div class="col-md-3 col-6" *ngIf="data.reportData?.date_ended">
            <div class="summary-metric">
              <span class="metric-label">Date Ended</span>
              <span class="metric-value">{{ formatDate(data.reportData?.date_ended) }}</span>
            </div>
          </div>
          <div class="col-md-3 col-6">
            <div class="summary-metric">
              <span class="metric-label">Event Expenses</span>
              <span class="metric-value">{{ formatCurrency(data.reportData?.package_costs) }}</span>
            </div>
          </div>
          <div class="col-md-3 col-6">
            <div class="summary-metric">
              <span class="metric-label">Transportation Costs</span>
              <span class="metric-value">{{ formatCurrency(data.reportData?.transportation_costs) }}</span>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Line Items Table for Misc -->
    <mat-card class="table-card mb-4" *ngIf="data.reportData?.line_items?.length">
      <mat-card-header>
        <mat-card-title>Line Items ({{ data.reportData.line_items.length }} items)</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="table-responsive">
          <table class="mat-table cdk-table w-100" role="table">
            <thead role="rowgroup">
              <tr>
                <th class="mat-header-cell">Date</th>
                <th class="mat-header-cell">Participant</th>
                <th class="mat-header-cell">Teacher</th>
                <th class="mat-header-cell">Payment Amount</th>
                <th class="mat-header-cell">Total Charges Due</th>
                <th class="mat-header-cell">Receipt #</th>
                <th class="mat-header-cell">Reported Week</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of data.reportData.line_items">
                <td class="mat-row">{{ formatDate(item.date) }}</td>
                <td class="mat-row">{{ item.participant_full_name || 'N/A' }}</td>
                <td class="mat-row">{{ getMiscTeacherName(item) }}</td>
                <td class="mat-row">{{ formatCurrency(item.payment_amount) }}</td>
                <td class="mat-row">{{ formatCurrency(item.total_charges_due) }}</td>
                <td class="mat-row">{{ item.receipt_number || '' }}</td>
                <td class="mat-row">{{ item.reported_week_number ? 'Wk ' + item.reported_week_number + '/' + item.reported_week_year : '' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Totals & Summary -->
    <mat-card class="table-card mb-4" *ngIf="data.reportData?.line_items?.length">
      <mat-card-header>
        <mat-card-title>Deductions &amp; Summary</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="table-responsive">
          <table class="mat-table cdk-table w-100" role="table">
            <tbody>
              <tr>
                <td class="mat-row"><strong>Totals</strong></td>
                <td class="mat-row">Total Charges Due: {{ formatCurrency(getMiscTotals().totalChargesDue) }}</td>
                <td class="mat-row">Amount of Payment: {{ formatCurrency(getMiscTotals().totalPayments) }}</td>
              </tr>
              <tr>
                <td class="mat-row">Transportation Charges</td>
                <td class="mat-row" colspan="2">{{ formatCurrency(data.reportData?.transportation_costs) }}</td>
              </tr>
              <tr>
                <td class="mat-row">Event Expenses</td>
                <td class="mat-row" colspan="2">{{ formatCurrency(data.reportData?.package_costs) }}</td>
              </tr>
              <tr>
                <td class="mat-row"><strong>Less Total Deductions</strong></td>
                <td class="mat-row" colspan="2"><strong>{{ formatCurrency((data.reportData?.transportation_costs || 0) + (data.reportData?.package_costs || 0)) }}</strong></td>
              </tr>
              <tr>
                <td class="mat-row"><strong>Total Subject To Percentage</strong></td>
                <td class="mat-row" colspan="2"><strong>{{ formatCurrency(getMiscTotals().totalPayments - (data.reportData?.transportation_costs || 0) - (data.reportData?.package_costs || 0)) }}</strong></td>
              </tr>
              <tr>
                <td class="mat-row">Royalty Amount Due at {{ data.reportData?.royalty_percentage || data.reportData?.studio?.royalty_percentage || 0 }}%</td>
                <td class="mat-row" colspan="2"><strong>{{ formatCurrency((getMiscTotals().totalPayments - (data.reportData?.transportation_costs || 0) - (data.reportData?.package_costs || 0)) * (data.reportData?.royalty_percentage || data.reportData?.studio?.royalty_percentage || 0) / 100) }}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-container>

  <!-- Studio Info Card -->
  <mat-card class="details-card" *ngIf="data.reportData?.studio">
    <mat-card-header>
      <mat-card-title>Studio Information</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="row">
        <div class="col-md-6">
          <div class="summary-metric">
            <span class="metric-label">Studio</span>
            <span class="metric-value">{{ getStudioName() }}</span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="summary-metric">
            <span class="metric-label">Address</span>
            <span class="metric-value">{{ getStudioAddress() }}</span>
          </div>
        </div>
        <div class="col-md-6" *ngIf="data.reportData?.studio?.phone">
          <div class="summary-metric">
            <span class="metric-label">Phone</span>
            <span class="metric-value">{{ data.reportData.studio.phone }}</span>
          </div>
        </div>
        <div class="col-md-6" *ngIf="data.reportData?.studio?.studio_email">
          <div class="summary-metric">
            <span class="metric-label">Email</span>
            <span class="metric-value">{{ data.reportData.studio.studio_email }}</span>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<mat-dialog-actions align="end">
  <button type="button" mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
